import UIAutoCompelete from "@/components/ui-controls/auto-complete";
import { getTimezones } from "@/store/slices/general/generalSlice";
import { useSelector } from "react-redux";

const TimeZoneField = ({
  onChange,
  form = {},
  isReadOnly = false,
  sx = {},
  fieldName = "timeZoneId",
  dropdownWidth = "auto",
  size = "small",
  title = "Select Time Zone",
  disableClearable = true,
}) => {
  const timezones = useSelector(getTimezones);

  return (
    <>
      <UIAutoCompelete
        handleChange={(value, e) => onChange(fieldName, value?.value)}
        handleTextChange={() => {}}
        options={timezones}
        name={fieldName}
        selected={
          timezones.find((tz) => tz.value == form?.values?.[fieldName]) || ""
        }
        loading={false}
        disableClearable={disableClearable}
        error={form.touched[fieldName] && form.errors[fieldName]}
        liStyles={{ alignSelf: "end", width: "100%" }}
        variant="outlined"
        isFilterWrapper={false}
        isMultiSelectEnable={false}
        freeSolo={false}
        title={title}
        size={size}
        helperTextStyles={{ position: "absolute", bottom: "-20px" }}
        disabled={isReadOnly}
        styles={sx}
        dropdownWidth={dropdownWidth}
      />
    </>
  );
};

export default TimeZoneField;
